import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import * as React from 'react';

export const busTourListToolbarRowSx = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
};

export const busTourListToolbarButtonSx = {
    flexShrink: 0,
    whiteSpace: 'nowrap',
};

const searchFieldSx = {
    width: 260,
    minWidth: 0,
    '@media (max-width: 449.95px)': {
        width: 'auto',
        flex: '1 1 0',
        minWidth: 0,
    },
};

const BusTourListSearchField = ({ value, onChange, sx }) => (
    <TextField
        size="small"
        variant="filled"
        hiddenLabel
        placeholder="Search"
        value={value}
        onChange={onChange}
        InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                    <SearchIcon />
                </InputAdornment>
            ),
        }}
        sx={{ ...searchFieldSx, ...sx }}
    />
);

export default BusTourListSearchField;
